export default "__VITE_ASSET__BaHYarXa__"